export const genKey = () =>
    Math.random()
        .toString(36)
        .slice(2);

export const addIds = (arr) => arr.map((value, id) => ({ id, value }));
